export namespace SchemaConverter {
    export function convertInchesToFeet(inches: number): string {
        let feet = Math.floor(inches / 12);
        let remaining_inches = inches % 12;
        return `${feet}' ${remaining_inches}"`
    }
}
